export function scrollToStep(stepID){
  const element = document.getElementById(stepID);
  element.scrollIntoView({behavior: "smooth", block: "start"})
}
